import { Button, InputField, RadioButton, TableWrapper } from 'components/Global';
import { ReactComponent as PeopleIcon } from 'icons/people-filled-icon.svg';
import { ReactComponent as ArrowLeft } from 'icons/arrow-left.svg';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from 'components/Context/AppContext';
import { useDispatch, useSelector } from 'react-redux';
import SelectFieldDropdown from 'components/Global/SelectFieldDropdown';
import { getAllCategories } from 'features/category/actions';
import { createInfluencer, generateReferralCode } from 'features/influencer/actions';
import Select from './select';
import { trackEvent } from 'utils/analytics';

const arrayRadionButton = [
  {
    id: 'pr1',
    label: 'Harga Fixed',
    value: 'fixed',
  },
  {
    id: 'pr2',
    label: 'Harga Percentage',
    value: 'percentage',
  },
];

export function isDecimal(num) {
  return num % 1 !== 0;
}

const InfluencerForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast, setShowSpinner } = useAppContext();

  const categories = useSelector((state) => state.category.data);

  const [influencerData, setInfluencerData] = useState({
    name: '',
    referral: '',
    min_rent: '',
    reference_link: '',
    services: [],
    categories: [],
    percentage_rule: undefined,
  });
  const [priceType, setPriceType] = useState('');
  // const [category_ids, setCategoryIds] = useState([]);
  const [comissionValue, setComissionValue] = useState({
    value_type: '',
    value: '',
  });

  useEffect(() => {
    dispatch(getAllCategories({ page: 1 }));
  }, []);

  const formattedCategories = useMemo(() => {
    return categories.category?.map((item) => ({ ...item, value: item.name.toLowerCase() }));
  }, [categories]);

  // setInfluencerData((prev) => ({
  //     ...prev,
  //     services: [...prev.services, rentTypeValue],
  //   }));

  const handleSelectCategory = (id, status) => {
    const existedType = influencerData.categories.find(
      (item) => item.id === categories.category?.find((el) => el.id == id)?.id,
    );

    if (existedType && status) return;
    const categoryValue = formattedCategories?.find((el) => el.id === id);

    if (status) {
      // setCategoryIds((prevState) => [
      //   ...prevState,
      //   { id: categoryValue.id, name: categoryValue.name, value: categoryValue.name.toLowerCase() },
      // ]);

      setInfluencerData((prev) => ({
        ...prev,
        categories: [
          ...prev.categories,
          { id: categoryValue.id, name: categoryValue.name, value: categoryValue.name.toLowerCase() },
        ],
      }));
    } else {
      const filteredData = influencerData.categories.filter((item) => item.id !== categoryValue.id);
      setInfluencerData((prev) => ({
        ...prev,
        categories: filteredData,
      }));
    }
  };

  const handleValueType = (id) => {
    setPriceType(id);
    const valueType = arrayRadionButton.find((item) => item.id == id)?.value;

    setComissionValue({ ...comissionValue, value_type: valueType });
  };

  const handleValueInput = (e) => {
    const normalizedValue = e.target.value.replace(',', '.');

    if (priceType === 'pr1') {
      // Allow only digits and negative sign
      if (/^\d*$/.test(normalizedValue)) {
        setComissionValue({ ...comissionValue, value: isNaN(parseInt(e.target.value)) ? '' : +normalizedValue });
      }
    } else {
      setComissionValue({ ...comissionValue, value: isNaN(parseInt(e.target.value)) ? '' : +normalizedValue });
    }
  };

  const handleTipeSewa = (id, status) => {
    const existedType = influencerData.services.find((item) => item === tipeSewa.find((el) => el.id == id)?.value);

    if (existedType && status) return;

    const rentTypeValue = tipeSewa.find((el) => el.id == id)?.value;

    if (status) {
      setInfluencerData((prev) => ({
        ...prev,
        services: [...prev.services, rentTypeValue],
      }));
    } else {
      const filteredData = influencerData.services.filter((item) => item !== rentTypeValue);
      setInfluencerData((prev) => ({
        ...prev,
        services: filteredData,
      }));
    }
  };

  const handleMinimumRent = (e) => {
    const normalizedValue = e.target.value.replace(',', '.');

    if (/^\d*$/.test(normalizedValue)) {
      setInfluencerData({ ...influencerData, min_rent: isNaN(parseInt(e.target.value)) ? '' : +normalizedValue });
    }
  };

  const numberInputOnWheelPreventChange = (e) => {
    e.target.blur();

    e.stopPropagation();
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  const submitHandler = async () => {
    if (influencerData.name.trim() === '') {
      return showToast({ type: 'warning', message: 'Harap Memasukan Nama Influencer' });
    } else if (influencerData.referral.trim() === '') {
      return showToast({ type: 'warning', message: 'Harap Memilih Kode Referral' });
    } else if (influencerData.services.length === 0) {
      return showToast({ type: 'warning', message: 'Harap Memilih Tipe Sewa' });
    } else if (influencerData.categories.length === 0) {
      return showToast({ type: 'warning', message: 'Harap Memilih Kategori Mobil' });
    } else if (priceType === 'pr2' && influencerData.percentage_rule === undefined) {
      return showToast({ type: 'warning', message: 'Harap Memilih Aturan Diskon' });
    } else if (isNaN(comissionValue.value) || comissionValue.value === '') {
      return showToast({ type: 'warning', message: 'Harap Mengisi Nilai Komisi' });
    } else if (comissionValue.value < 0) {
      return showToast({ type: 'warning', message: 'Nilai Komisi Tidak Valid' });
    } else if (comissionValue.value_type === 'fixed' && isDecimal(comissionValue.value)) {
      return showToast({ type: 'warning', message: 'Nilai Komisi Tidak Valid' });
    } else if (typeof influencerData.min_rent === 'string' && influencerData.min_rent.trim() === '') {
      return showToast({ type: 'warning', message: 'Harap Mengisi Minimal Sewa' });
    }

    const payload = {
      fullname: influencerData.name,
      referral: influencerData.referral,
      value_type: comissionValue.value_type,
      value: comissionValue.value,
      reference_link: influencerData.reference_link,
      services: influencerData.services,
      categories: influencerData.categories.map((item) => item.id),
      min_duration: influencerData.min_rent,
      ...(priceType === 'pr2' && { percentage_rule: influencerData.percentage_rule }),
    };

    try {
      setShowSpinner(true);
      trackEvent('influencer_created', {
        source: 'influencer_form',
      });
      await dispatch(createInfluencer(payload)).unwrap();
      showToast({ type: 'success', message: 'Berhasil Menambah Influencer Baru' });
      navigate('/influencer');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      showToast({ type: 'error', message: 'Gagal Menambah Influencer Baru' });
    } finally {
      setShowSpinner(false);
    }
  };

  const generateRandomCode = async () => {
    trackEvent('referral_code_generated', {
      source: 'influencer_form',
    });
    const res = await dispatch(generateReferralCode(influencerData.name)).unwrap();
    setInfluencerData((prev) => ({ ...prev, referral: res.code }));
  };

  const handleGenerateLink = () => {
    const value = influencerData.referral.trim();
    const domain = window.location.origin;
    const excludeStringBackOffice = domain.replace('backoffices.', '');

    if (value) {
      const link = `${excludeStringBackOffice}/event/${encodeURIComponent(value)}`;
      setInfluencerData((prev) => ({ ...prev, reference_link: link }));
    }
  };

  const handleCopyLink = async () => {
    const link = influencerData.reference_link;

    try {
      await navigator.clipboard.writeText(link);
      showToast({ type: 'success', message: 'Berhasil Copy Link Referral' });
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal Copy Link Referral' });
    }
  };

  return (
    <div className="new-influencer">
      <button className="back-btn" onClick={() => navigate(-1)}>
        <ArrowLeft />
        <span>Kembali</span>
      </button>

      <TableWrapper title="Tambah Influencer" icon={<PeopleIcon fill="#FF9900" width="25px" height="25px" />}>
        <div className="new-influencer__form">
          <InputField
            label="Nama Influencer"
            placeholder="Tulis Nama Influencer"
            value={influencerData.name || ''}
            onChange={(e) => setInfluencerData((prev) => ({ ...prev, name: e.target.value }))}
          />

          <div className="referral-code-field">
            <InputField
              label="Kode Referral"
              placeholder="Kode Referral"
              value={influencerData.referral || ''}
              onChange={(e) => setInfluencerData((prev) => ({ ...prev, referral: e.target.value }))}
            />
            <Button className="random-code-btn" disabled={!influencerData.name} onClick={generateRandomCode}>
              Random Code
            </Button>
          </div>

          <SelectFieldDropdown
            label="Tipe Sewa"
            htmlFor="tipe-sewa"
            data={tipeSewa}
            placeholder="Tipe Sewa"
            value={influencerData.services}
            onChange={handleTipeSewa}
            checkBox
          />

          <SelectFieldDropdown
            label="Pilih Kategori Mobil"
            htmlFor="pilih-kategori-mobil"
            placeholder="Pilih Kategori Mobil"
            data={formattedCategories}
            value={influencerData.categories}
            onChange={handleSelectCategory}
            checkBox
          />

          <div className="commission-field">
            <h3>Komisi</h3>
            <div className="radio">
              <RadioButton name="price" data={arrayRadionButton} state={priceType} setState={handleValueType} />
            </div>

            {(priceType === 'pr1' || priceType === '') && (
              <InputField
                type="number"
                placeholder="Rp 0"
                value={comissionValue.value}
                onChange={handleValueInput}
                onWheel={numberInputOnWheelPreventChange}
                disable={!priceType}
                min={0}
              />
            )}

            {priceType === 'pr2' && (
              <div className="commission-controls">
                <Select
                  options={percentage_rule}
                  value={influencerData.percentage_rule}
                  onChange={(val) => setInfluencerData((prev) => ({ ...prev, percentage_rule: val }))}
                  placeholder="Pilih Kondisi"
                />

                <InputField
                  type="number"
                  placeholder="0%"
                  value={comissionValue.value}
                  onChange={handleValueInput}
                  onWheel={numberInputOnWheelPreventChange}
                  disable={!priceType}
                  min={0}
                />
              </div>
            )}
          </div>

          <InputField
            label="Minimal Sewa (Hari)"
            type="number"
            placeholder="Tulis Minimal Sewa"
            value={influencerData.min_rent}
            onChange={handleMinimumRent}
            onWheel={numberInputOnWheelPreventChange}
            min={0}
          />

          <div className="referral-link-field">
            <InputField
              label="Generate Link"
              placeholder="Link Referral"
              value={influencerData.reference_link || ''}
              disable
              readOnly
            />

            <div className="btn-wrapper">
              <Button className="btn copy-btn" disabled={!influencerData.referral} onClick={handleCopyLink}>
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="30" height="30" rx="3" fill="currentColor" />
                  <path
                    d="M21.4167 5.8335C21.9029 5.8335 22.3692 6.02665 22.713 6.37047C23.0568 6.71428 23.25 7.1806 23.25 7.66683V18.6668C23.25 19.1531 23.0568 19.6194 22.713 19.9632C22.3692 20.307 21.9029 20.5002 21.4167 20.5002H19.5833V22.3335C19.5833 22.8197 19.3902 23.286 19.0464 23.6299C18.7025 23.9737 18.2362 24.1668 17.75 24.1668H8.58333C8.0971 24.1668 7.63079 23.9737 7.28697 23.6299C6.94315 23.286 6.75 22.8197 6.75 22.3335V11.3335C6.75 10.8473 6.94315 10.381 7.28697 10.0371C7.63079 9.69332 8.0971 9.50016 8.58333 9.50016H10.4167V7.66683C10.4167 7.1806 10.6098 6.71428 10.9536 6.37047C11.2975 6.02665 11.7638 5.8335 12.25 5.8335H21.4167ZM13.1667 17.7502H11.3333C11.0997 17.7504 10.875 17.8399 10.7051 18.0003C10.5352 18.1607 10.433 18.3799 10.4193 18.6131C10.4056 18.8463 10.4815 19.076 10.6314 19.2552C10.7814 19.4343 10.9941 19.5495 11.2261 19.5771L11.3333 19.5835H13.1667C13.4003 19.5832 13.625 19.4938 13.7949 19.3334C13.9648 19.173 14.067 18.9538 14.0807 18.7206C14.0944 18.4873 14.0185 18.2576 13.8686 18.0785C13.7186 17.8993 13.5059 17.7842 13.2739 17.7566L13.1667 17.7502ZM21.4167 7.66683H12.25V9.50016H17.75C18.2362 9.50016 18.7025 9.69332 19.0464 10.0371C19.3902 10.381 19.5833 10.8473 19.5833 11.3335V18.6668H21.4167V7.66683ZM15 14.0835H11.3333C11.0902 14.0835 10.8571 14.1801 10.6852 14.352C10.5132 14.5239 10.4167 14.757 10.4167 15.0002C10.4167 15.2433 10.5132 15.4764 10.6852 15.6483C10.8571 15.8203 11.0902 15.9168 11.3333 15.9168H15C15.2431 15.9168 15.4763 15.8203 15.6482 15.6483C15.8201 15.4764 15.9167 15.2433 15.9167 15.0002C15.9167 14.757 15.8201 14.5239 15.6482 14.352C15.4763 14.1801 15.2431 14.0835 15 14.0835Z"
                    fill="white"
                  />
                </svg>
              </Button>
              <Button className="btn generate-btn" disabled={!influencerData.referral} onClick={handleGenerateLink}>
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="30" height="30" rx="3" fill="currentColor" />
                  <path
                    d="M21.4167 6.75H8.58333C8.0971 6.75 7.63079 6.94315 7.28697 7.28697C6.94315 7.63079 6.75 8.0971 6.75 8.58333V21.4167C6.75 21.9029 6.94315 22.3692 7.28697 22.713C7.63079 23.0568 8.0971 23.25 8.58333 23.25H21.4167C21.9029 23.25 22.3692 23.0568 22.713 22.713C23.0568 22.3692 23.25 21.9029 23.25 21.4167V8.58333C23.25 8.0971 23.0568 7.63079 22.713 7.28697C22.3692 6.94315 21.9029 6.75 21.4167 6.75ZM16.7783 17.5758L14.7525 19.5833C14.1567 20.1975 13.3683 20.5 12.58 20.5C11.7917 20.5 11.0033 20.1975 10.4167 19.5833C9.1975 18.4008 9.1975 16.4483 10.4167 15.2383L11.6542 13.9917L11.645 14.5417C11.6358 15 11.7092 15.4583 11.8558 15.8617L11.9017 15.9992L11.535 16.375C11.3961 16.5113 11.2857 16.6739 11.2104 16.8533C11.1351 17.0328 11.0963 17.2254 11.0963 17.42C11.0963 17.6146 11.1351 17.8072 11.2104 17.9867C11.2857 18.1661 11.3961 18.3287 11.535 18.465C12.0942 19.0333 13.0658 19.0333 13.625 18.465L15.6417 16.4575C15.9167 16.1733 16.0817 15.7975 16.0817 15.4033C16.0817 15 15.9167 14.6425 15.6417 14.3583C15.5663 14.2841 15.5064 14.1957 15.4655 14.0981C15.4247 14.0005 15.4036 13.8958 15.4036 13.79C15.4036 13.6842 15.4247 13.5795 15.4655 13.4819C15.5064 13.3843 15.5663 13.2959 15.6417 13.2217C15.9442 12.9192 16.4758 12.9283 16.7783 13.2217C17.3558 13.8083 17.6767 14.5783 17.6767 15.4033C17.6767 16.2283 17.3558 16.9983 16.7783 17.5758ZM19.5833 14.7617L18.355 16.0083V15.4583C18.3642 15 18.2908 14.5417 18.1442 14.1383L18.0983 14.01L18.465 13.625C18.6039 13.4887 18.7143 13.3261 18.7896 13.1467C18.8649 12.9672 18.9037 12.7746 18.9037 12.58C18.9037 12.3854 18.8649 12.1928 18.7896 12.0133C18.7143 11.8339 18.6039 11.6713 18.465 11.535C17.9058 10.9667 16.925 10.9758 16.375 11.535L14.3583 13.5517C14.0833 13.8267 13.9183 14.2025 13.9183 14.5967C13.9183 15 14.0833 15.3575 14.3583 15.6417C14.5142 15.7883 14.5967 15.99 14.5967 16.21C14.5967 16.43 14.5142 16.6317 14.3583 16.7783C14.2837 16.8525 14.195 16.911 14.0973 16.9504C13.9997 16.9898 13.8952 17.0092 13.79 17.0075C13.5883 17.0075 13.3775 16.9342 13.2217 16.7783C12.6445 16.2008 12.3204 15.4177 12.3204 14.6012C12.3204 13.7848 12.6445 13.0017 13.2217 12.4242L15.2475 10.4167C15.53 10.1281 15.8673 9.89891 16.2396 9.74241C16.6118 9.58592 17.0116 9.50531 17.4154 9.50531C17.8192 9.50531 18.219 9.58592 18.5913 9.74241C18.9635 9.89891 19.3008 10.1281 19.5833 10.4167C20.1792 10.985 20.5 11.755 20.5 12.58C20.5 13.405 20.1792 14.175 19.5833 14.7617Z"
                    fill="white"
                  />
                </svg>
              </Button>
            </div>
          </div>
        </div>
        <div className="buttons">
          <Button variant="outline" className="button" width={208} size="sm" onClick={() => navigate(-1)}>
            Kembali
          </Button>
          <Button className="button" width={208} size="sm" onClick={submitHandler}>
            Simpan
          </Button>
        </div>
      </TableWrapper>
    </div>
  );
};

export default InfluencerForm;

const tipeSewa = [
  {
    id: 0,
    name: 'Dengan Supir',
    value: 'with_driver',
  },
  {
    id: 1,
    name: 'Tanpa Supir',
    value: 'without_driver',
  },
  {
    id: 2,
    name: 'Airport Transfer',
    value: 'airport_transfer',
  },
];

const percentage_rule = [
  {
    name: 'Dari Total Harga Pesanan',
    id: 'order_total',
  },
  {
    name: 'Dari Total Harga Kendaraan',
    id: 'vehicle_total',
  },
];
